export default "__VITE_ASSET__f8ecbb61__"